import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.364 18.364C20.0518 16.6762 21 14.387 21 12C21 9.61304 20.0518 7.32384 18.364 5.636C16.6762 3.94816 14.387 2.99995 12 2.99995C9.61303 2.99995 7.32383 3.94816 5.63599 5.636M18.364 18.364C16.6762 20.0518 14.387 21.0001 12 21.0001C9.61303 21.0001 7.32383 20.0518 5.63599 18.364C3.94816 16.6762 2.99994 14.387 2.99994 12C2.99994 9.61304 3.94816 7.32384 5.63599 5.636M18.364 18.364L5.63599 5.636",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }